module.exports = __webpack_public_path__ + "img/13.8ba6b020.jpg";